import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WhatsappLinksStateInterface, WhatsappLinkInterface } from '../../domain/interfaces/WhatsappLinkInterface';



const initialState: WhatsappLinksStateInterface = {
    links: [],
    loading: false,
    error: null,
};

const whatsappLinksSlice = createSlice({
    name: 'whatsappLinks',
    initialState,
    reducers: {
        fetchLinksStart(state) {
            state.loading = true;
            state.error = null;
        },
        fetchLinksSuccess(state, action: PayloadAction<WhatsappLinkInterface[]>) {
            state.loading = false;
            state.links = action.payload;
        },
        fetchLinksFailure(state, action: PayloadAction<string>) {
            state.loading = false;
            state.error = action.payload;
        },
        clearLinksError(state) {
            state.error = null;
        },
    },
});

export const {
    fetchLinksStart,
    fetchLinksSuccess,
    fetchLinksFailure,
    clearLinksError,
} = whatsappLinksSlice.actions;

export default whatsappLinksSlice.reducer;

